"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _grid = require("../grid");

var _type = require("../_util/type");

var _default = (0, _type.withInstall)(_grid.Row);

exports.default = _default;